import React, { useEffect, useState, useContext } from 'react';
import * as R from 'ramda';
import { indexReduce, convertDateToLocalTime } from '@cd/utils';
//import styles from './css/ApplyPaymentToInvoices.scss';
import { store } from '../store';
import { InputRHF } from '@cd/rhf';
import { DateRHF } from '@cd/rhf';
import { FormCardRHF } from '@cd/rhf';
import getHistoryListDefaultHOCEnhance from './../../main/HistoryListDefaultHOC';
import HistoryList from '../../main/HistoryList';
import { useFunctionAsState } from '../../utilsReact';
import { DropDownRHF } from '@cd/rhf';
import useGenerateCharge from '../fetch/useGenerateCharge';
import { Box } from '@mui/material';
import { css } from '@emotion/react';

const wrapStyle = css({
	display: 'flex',
	justifyContent: 'space-between',
	gap: '16px',
	form: { flex: 1 }
});
const totalLineStyle = css({ display: 'flex', justifyContent: 'flex-end' });

function getRecord({ clientID, selected }) {
	return {
		clientID,
		productID: selected?.[0].id ?? 0,
		months: 1,
		invoiceDate: new Date(),
		chargeDate: new Date(),

		...indexReduce(
			(acc, val, index) => R.assoc(`amount-${index}`, val.a1, acc),
			{},
			selected
		)
	};
}

const sumSelectedAmount = R.compose(
	R.reduce(R.add, 0),
	R.map(R.compose(v => +v, R.replace(/[$,]/gi, ''))),
	R.tap(item => console.log(':', item)),
	R.pluck('a1')
);

const Months = R.times(
	n => ({
		name: `${n + 1} month${n + 1 > 1 ? 's' : ''}`,
		id: n + 1
	}),
	12
);

const GenerateCharge = ({ selected, clientID }) => {
	const { dispatch } = useContext(store);
	const { mutate } = useGenerateCharge(dispatch);
	const [record, setRecord] = useState(getRecord({ clientID, selected }));
	const [InvoiceList, setInvoiceList] = useFunctionAsState(null);

	/* useEffect(() => {
		if (isSuccess) {
			dispatch({ type: 'post success', message: 'INVOICE CREATED!' });
		}
	}, [isSuccess]); */

	useEffect(() => {
		const InvoiceList = getHistoryListDefaultHOCEnhance({
			store,
			method: 'GET',
			url: `/get/product/invoices/${clientID}/${selected?.[0].id}`,
			options: {
				reactQuery: { queryName: 'getProductInvoices' }
			}
		})(HistoryList);
		setInvoiceList(InvoiceList);
		setRecord(getRecord({ clientID, selected }));
	}, [selected]);

	return (
		<Box sx={wrapStyle}>
			{record && (
				<FormCardRHF
					onSubmit={data =>
						mutate(
							R.evolve(
								{
									chargeDate: d =>
										convertDateToLocalTime('MM/dd/yyyy', d),
									invoiceDate: d =>
										convertDateToLocalTime('MM/dd/yyyy', d)
								},
								data
							)
						)
					}
					title="CREATE CHARGES"
					subtitle="Create these charges"
					okButtonTitle="DO IT"
					validateForm=""
					handleChange=""
					ignoreDirty
					defaultValues={record}>
					{selected.map((v, i) => (
						<InputRHF
							name={`amount-${i}`}
							label={`Amount: ${i}`}
							fullWidth
						/>
					))}

					<div css={totalLineStyle}>
						Total Selected: $
						{selected && sumSelectedAmount(selected)}
					</div>
					<DateRHF name="chargeDate" label="Charge Date" fullWidth />
					<DateRHF
						name="invoiceDate"
						label="Invoice Date"
						fullWidth
					/>
					<InputRHF name="clientID" label="ClientID" fullWidth />
					<InputRHF name="productID" label="ProductID" fullWidth />
					<DropDownRHF
						name="months"
						defaultValue={1}
						label="Date Input"
						options={Months}
						fullWidth
					/>
				</FormCardRHF>
			)}
			{InvoiceList && (
				<InvoiceList
					title="Invoice List"
					onDataLoaded={([first]) =>
						first &&
						setRecord(
							R.assoc('chargeDate', new Date(first.v1), record)
						)
					}
					onClick={(i, { v1 }) => {
						console.log('i', i, v1);

						setRecord(R.assoc('chargeDate', new Date(v1), record));
					}}
				/>
			)}
		</Box>
	);
};

export default GenerateCharge;
